export interface ProjectI {
  id: number;
  name: string;
}

export interface PermissionI {
  id: number;
  name: string;
  resourceID: number;
  resourceName: string;
}

export interface UserI {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  isActive: boolean;
  resetPassword: boolean;
  lang: string;
  twoFactors: boolean;
}

export interface GoogleUserI {
  email: string;
  familyName: string;
  givenName: string;
  name: string;
  picture: string;
  verifiedEmail: boolean;
}

export interface GoogleProjectI {
  name: string;
  projectId: string;
  projectNumber: string;
}

export interface AuthStateI {
  token: string;
  projects: ProjectI[];
  permissions: PermissionI[];
  user?: UserI;
  project?: ProjectI;
  googleUser?: GoogleUserI;
  googleProjects?: GoogleProjectI[];
  googleProject?: GoogleProjectI;
}

export interface SendCodeI {
  email: string;
  code?: string;
  app?: string;
}

export const state: AuthStateI = {
  token: '',
  projects: [],
  permissions: [],
  googleProject: {
    name: '',
    projectId: '',
    projectNumber: '',
  },
};
